import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { CalendarInputWrapper } from 'secondstep-components'

export const ProgramStartDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 2.063rem;
  margin-bottom: 2.5rem;

  ${CalendarInputWrapper} {
    border-color: ${themeGet('colors.blueGrayMedium')};
  }
`

export const ProgramStartDateLabel = styled.label`
  color: ${themeGet('colors.darkGray')};
  text-align: start;
  margin-top: -0.188rem;
  margin-bottom: 0.063rem;
`
